import { ROUTES } from './routing'

import {
  accessControlSubNavigation,
  accessControlSubNavigationWithUserTypes,
} from 'setups/controller'
import { projectClient } from 'constants/project'

export const SubsquadTabModulesData = [
  {
    module: 'Member',
    route: {
      title: 'Members',
      path: ROUTES.MerchantProfileTransactions,
      pathname: 'members',
      className:
        'text-black py-2 mx-3 block hover:text-primary focus:font-bold focus:outline-none',
    },
  },
]

export const SUBSQUADTABSNAVIGATION_OLD = accessControlSubNavigation(
  projectClient,
  SubsquadTabModulesData,
  'subsquad'
)

export const SUBSQUADTABSNAVIGATION = accessControlSubNavigationWithUserTypes({
  projectClient,
  navModules: SubsquadTabModulesData,
  navModule: 'subsquad',
  userType: 'display_user',
  isTempBypass: true,
})
